
import { useMutation } from "react-query"
import { useToast } from "../../hook/usetoast";
import DataService from '../../config/DataServices'

const { postRequest} = DataService()






export const useRegister = () => {
    const toast = useToast();

    return useMutation({
        mutationFn: data => {
            return postRequest("user/register", { ...data })
        },
        onSuccess: success => {

            if (!success?.status) {
                return toast.error(success?.message)
            }
            return toast.success(success?.message)
        }
    })
}


export const useUserCreate = () => {
    const toast = useToast();

    return useMutation({
        mutationFn: data => {
            return postRequest("user/completeUserVerify", { ...data })
        },
        onSuccess: success => {

            if (!success?.status) {
                return toast.error(success?.message)
            }
            return toast.success(success?.message)
        }
    })
}


export const useSendOTP = () => {
    const toast = useToast();

    return useMutation({
        mutationFn: data => {
            return postRequest("user/userRegister", { ...data })
        },
        onSuccess: success => {
            if (!success?.status) {
                return toast.error(success?.message)
            }
            return toast.success(success?.message)

        }

    })
}

export const useVerifyOtp = () => {
    const toast = useToast();

    return useMutation({
        mutationFn: data => {
            return postRequest("user/phone-otp-verify", { ...data })
        },
        onSuccess: success => {
            if (!success?.status) {
                return toast.error(success?.message)
            }
            return toast.success(success?.message)

        }
    })
}